<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-31 14:01:30
 * @LastEditTime: 2020-09-25 15:30:05
 * @Description: 根文件
--> 
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
const acknowledge = require("socket.io-acknowledge");

export default {
  sockets: {
    async connect() {
      console.log("connect success");
      // try {
      //   const a = await this.$socket.emit("receive:create", {
      //     company: "606d78fc6c901b41c8881526",
      //     customer: "60b9d5b50b45fb0ed81773af",
      //     estAmount: 111,
      //     type: "trans",
      //   });
      //   console.log("a:", a);
      // } catch (error) {
      //   console.log("error", error);
      // }
    },
    receive_create(data) {
      this.socketAddReceive(data);
      this.$Message.info("用户" + data.createdBy.name + "创建了一个回款记录");
    },
    receive_update(data) {
      this.socketUpdateReceive(data);
      this.$Message.info("用户" + data.createdBy.name + "更新了一个回款记录");
    },
    so_create(data) {
      // this.createSalesOrder(data);
      this.$Message.info(
        "用户" + data[0]?.createdBy.name + "创建了一个销售订单"
      );
    },
    so_update(data) {
      // this.socketUpdateReceive(data);
      this.$Message.info("用户" + data?.createdBy.name + "更新了一个销售订单");
    }
    // receive_delete(data) {
    //   console.log(data);
    //   this.socketDeleteReceive(data);
    //   this.$Message.info("用户" + data.createdBy.name + "更新了一个回款记录");
    // },
    // async createdSalesOrder(data) {
    //   // 只有这些权限才有提醒
    //   if (
    //     this.user.superAdmin ||
    //     arrayIntersection(
    //       [
    //         "factoryLeader",
    //         "allFactoryLeader",
    //         "salesAssist",
    //         "sales",
    //         "salesLead",
    //         "deliveryLeader",
    //         "deliveryAssist",
    //       ],
    //       this.user.simpleRole
    //     ).length > 0
    //   ) {
    //     // 如果是销售或者销售经理
    //     if (
    //       ["sales", "salesLead"].arrayIntersection(this.user.simpleRole)
    //         .length > 0
    //     ) {
    //       const departmentList = data.sales.customer.department
    //         ? data.sales.customer.department.map((x) => x._id)
    //         : [];
    //       const userList = data.sales.customer.user
    //         ? data.sales.customer.user.map((x) => x._id)
    //         : [];
    //       if (
    //         departmentList.includes(this.user.department._id) ||
    //         userList.includes(this.user._id)
    //       ) {
    //         return this.setSalesOrderMessage(data);
    //       } else {
    //         return;
    //       }
    //     }
    //     if (this.user.factoryRole && this.user.factoryRole.length > 0) {
    //       const factoryList = this.user.factoryRole.map((x) => x._id);
    //       if (factoryList.includes(data.factory._id)) {
    //         return this.setSalesOrderMessage(data);
    //       } else {
    //         return;
    //       }
    //     }
    //     this.setSalesOrderMessage(data);
    //   }
    // },
  },
  methods: {
    ...mapActions({
      socketAddReceive: "receive/socketAddReceiveAction",
      // createSalesOrder: "salesOrder/createSalesOrderAction",
      // socketDeleteReceive: "receive/socketDeleteReceiveAction",
      socketUpdateReceive: "receive/socketUpdateReceiveAction",
      getMyInfo: "auth/getMyInfoAction"
    }),
    // ...mapMutations({
    //   setUserInfo: "auth/SETCURRENTUSER"
    // }),
    setSalesOrderMessage(data) {
      if (
        this.planArrivedAt &&
        dayjs(data.planArrivedAt).get("date") ===
          dayjs(this.planArrivedAt).get("date")
      ) {
        this.$store.commit("salesOrder/UPDATESALESORDERLIST", data);
      }
      // this.$Notice.info({
      //   title: "有新的销售订单",
      //   desc: `${
      //     data.sales.abbr
      //       ? data.sales.abbr
      //       : data.sales &&
      //         data.sales.customer.name + "-" + data.sales.material.name
      //   }&emsp;${dayjs(data.createdAt).format("HH:mm")}`
      // });
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.currentUser,
      planArrivedAt: state => state.salesOrder.planArrivedAt
    })
  },
  async created() {
    acknowledge(this.$socket);
  },
  async mounted() {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await this.getMyInfo();
        if (this.user.needResetPassword) {
          this.$router.push("/changePassword");
        }
      } catch (error) {
        console.log('获取用户信息失败');
        console.log(error);
      }
    }
  }
};
</script>
<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
  height 100%
  width 100%
  font-size 12px

  span
    font-weight 450

#nav
  padding 30px

  a
    font-weight bold
    color #2c3e50

    &.router-link-exact-active
      color #42b983

body
  overflow hidden

.ivu-menu-submenu-title .ivu-dropdown-item
  -webkit-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none

// 销售配方的新增Drawer 把padding去掉
.ivu-drawer-body
  padding 0 !important

.drawer-content
  padding 16px
  height 100%
  width 100%

// Tab内容的高充满
.ivu-tabs
  height 100%

// 表单label加粗
.ivu-form-item-label
  font-weight 800

// 让Tab的内容充满
.ivu-tabs-content
  height calc(100% - 52px)

  .ivu-tabs-tabpane
    height 100%
    overflow-y auto

// 表格body内部可以滚动
// .ivu-table-wrapper
// height 100%

// .ivu-table .ivu-table-default {
// max-height: 100%;
// }
// .ivu-table-body
// max-height calc(100% - 40px)
// overflow-y auto

// 让表格的下拉菜单可以粗来
// .ivu-table-wrapper {
// overflow: visible !important;
// }
.ivu-table .color-0 td
  background-color hsl(347, 100%, 97%)

.ivu-table .color-1 td
  background-color hsl(240, 100%, 97%)

.ivu-table .color-2 td
  background-color hsl(124, 100%, 97%)

.ivu-table .red-0
  color lightsalmon

.ivu-table .red-1
  color red

.ivu-table .green-0
  color lightgreen

.ivu-table .green-1
  color green

.ivu-table .green-2
  color darkgreen

.ivu-table .yellow-1
  color yellow

.ivu-table .seagreen-0
  color lightseagreen

.ivu-table .blue-1
  color blue

.ivu-table .blue-2
  color darkblue

.ivu-table .purple-1
  color darkmagenta

.ivu-table .yellow-1
  color yellow

.ivu-table .canceled td
  color darkgray
  text-decoration line-through

.ivu-page-simple .ivu-page-simple-pager input
  width 38px !important

// 让步骤条文字对齐
.ivu-steps .ivu-steps-title
  line-height 18px
  margin-bottom 0

.ivu-table td
  height 29px !important

.ivu-table-header thead tr th .ivu-table-fixed-header thead tr th
  padding 2px 0 !important

.ivu-table-cell
  padding-left 8px !important
  padding-right 8px !important

// .ivu-table-fixed, .ivu-table-fixed-right {
//   height: 100% !important;
// }
// .ivu-table-fixed-body {
//   height: calc(~'100% - 63px') !important;
// }
</style>
